import React from 'react';
import { connect } from 'dva';
import Loading from 'components/Loading';

@connect(({ login, loading }) => ({
  loading: loading.effects['login/login'],
}))
class Login extends React.Component {
  componentDidMount() {
    const urlParams = (this.props.location && this.props.location.query) || {};
    this.props.dispatch({
      type: 'login/login',
      payload: urlParams,
    });
  }

  render() {
    const { loading } = this.props;

    return <Loading loading={loading}></Loading>;
  }
}

export default Login;
